module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tf-a1e1b04e6e2a9933509841a0cf86faa2.svg";